import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import ActionButton from "../general/ActionButton";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import { getBrokerInformation, verifyToken } from "../store/broker";
import { getBrokerageInformation, getDetails } from "../store/brokerage";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-dropdown-select";
import UploadBrokerImage from "../components/UploadBrokerImage";
import ReactSelect from "react-select";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  getAllUsersList,
  getAllUsers,
  addNewUser,
  getUpdateErrors,
  getBrokerageInfo,
} from "../store/userManagement";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import { sendSignupEmail, storeEmailId } from "../store/passwordManagement";

import translations from "../utils/translations";
const UserManagement = () => {
  return <UserManagementPane></UserManagementPane>;
};
const UserManagementPane = () => {
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);

  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  const brokerageAdminTranslations =
    translations[languagepreference].brokerageAdmin;

  let data = { brokerage_code: broker.information.brokerages[0].code };
  const [addressList, setAddressList] = useState(null);
  useEffect(() => {
    dispatch(getUserDetails(data)).then(
      setTimeout(() => {
        dispatch(getDetails(data));
      }, 100)
    );
  }, []);
  const brokerage_info = useSelector(getBrokerageInformation);
  useEffect(() => {
    setAddressList(brokerage_info);
  }, [brokerage_info]);

  let userList = useSelector(getUserInformation);

  const onUpdateChangeHandle = (value) => {
    dispatch(toggleUpdateButton(value));
  };

  const onNewUserModelChangeHandle = (value) => {
    dispatch(getAllUsers());
    dispatch(toggleNewUserModel(value));
  };

  const onUpdateUserModelChangeHandle = (value, user) => {
    dispatch(selectUpdateUser(user));

    dispatch(toggleUpdateUserModel(value));
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            {
              translations[languagepreference].brokerageAdmin
                .contactDetailHeader
            }
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
              maxHeight:"60vh",
              overflowY:"auto"
            }}
          >
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">{brokerageAdminTranslations.userName}</th>
                  <th scope="col" className="text-center">
                    {brokerageAdminTranslations.admin}
                  </th>
                  <th scope="col" className="text-center">
                    {brokerageAdminTranslations.active}
                  </th>
                  <th scope="col">{brokerageAdminTranslations.email}</th>
                  <th scope="col">
                    {brokerageAdminTranslations.contactNumber}
                  </th>
                  <th scope="col">{brokerageAdminTranslations.location}</th>
                  <th scope="col" className="text-center">
                    {brokerageAdminTranslations.action}
                  </th>
                </tr>
              </thead>
              <tbody>
                {userList.map((user, index) => {
                  // Simplified city extraction logic
                  const city =
                    user.location ||
                    user.brokerages?.[0]?.address?.[0]?.city ||
                    user.brokerages?.[0]?.address?.city ||
                    "";

                  return (
                    <tr key={index}>
                      <td>{`${user.firstname} ${user.lastname}`}</td>
                      <td className="text-center">
                        {user.isadmin ? (
                          <span>{brokerageAdminTranslations.yes}</span>
                        ) : (
                          <span>{brokerageAdminTranslations.no}</span>
                        )}
                      </td>
                      <td className="text-center">
                        {user.isactive ? (
                          <span>{brokerageAdminTranslations.yes}</span>
                        ) : (
                          <span>{brokerageAdminTranslations.no}</span>
                        )}
                      </td>
                      <td>{user.user.email}</td>
                      <td>{user.phonenumber}</td>
                      <td>{city}</td>
                      <td className="text-center">
                        <ActionButton
                          text={brokerageAdminTranslations.update}
                          onClick={() =>
                            onUpdateUserModelChangeHandle(true, user)
                          }
                          style={{
                            backgroundColor: theme.COLORS.secondary_skyblue,
                            width: "auto",
                            minWidth: "80px",
                            height: "auto",
                            maxHeight: "none",
                            minHeight: "35px"
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            <ActionButton
              text={translations[languagepreference].brokerageAdmin.addNewUser}
              onClick={() => onNewUserModelChangeHandle(true)}
              style={{
                backgroundColor: theme.COLORS.secondary_skyblue,
                width: "auto",
                minWidth: "200px",
                maxWidth: "100%",
                height: "auto",
                maxHeight: "none",
                minHeight: "40px"
              }}
            />
          </div>
        </div>
      </div>
      <AddUserModal
        brokerageCode={data.brokerage_code}
        brokerageAddressList={addressList ? addressList.address : []}
      ></AddUserModal>
      <UpdateUserModal
        brokerageCode={data.brokerage_code}
        brokerageAddressList={addressList ? addressList.address : []}
      ></UpdateUserModal>
    </div>
  );
};

const AddUserModal = (props) => {
  const newUserModalState = useSelector(geNewUserModelStatus);

  return (
    <Modal
      size="md"
      isOpen={newUserModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "95vh",
          width: "40vw",
          position: "absolute",
          top: "2vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <NewUser
        brokerageCode={props.brokerageCode}
        brokerageAddressList={props.brokerageAddressList}
      ></NewUser>
    </Modal>
  );
};

const NewUser = (props) => {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  let allUsers = useSelector(getAllUsersList);
  const updateErrors = useSelector(getUpdateErrors);
  const [newuser, setNewuser] = useState(null);
  const onUserSelection = (value) => {
    if (value[0]) {
      setNewuser(value[0].email);
    }
  };

  const [name, setName] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [active, setActive] = useState(true);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [password, setPassword] = useState(null);
  const [location, setLocation] = useState(null);
  const [role, setJobRole] = useState(null);
  const [bio, setBio] = useState(null);
  const languagepreference = broker.information.languagepreference;

  const brokerageAdminTranslations =
    translations[languagepreference].brokerageAdmin;
  const user = {
    firstname: name,
    email: email,
    password: password,
    phonenumber: phone,
    location: location,
    jobrole: role,
    bio: bio,
    isadmin: admin,
    isactive: active,
    brokeragecodes: [broker.information.brokerages[0].code],
    
  };
  const [selecteduser, setSelecteduser] = useState({
    uName: user.firstname + " " + user.lastname,
    uEmail: user.email,
    uContact: user.phonenumber,
    uLocation: location,
    uImage: user.image,
    uRole: user.jobrole,
    uBiography: user.bio,
    uActive: user.isactive,
    uAdmin: user.isadmin,
    languagePreference: user.languagePreference,
  });
  const previewCanvasRef = useRef(null);
  const onAddButtonClick = () => {
    let data = {
      firstname: name,
      email: email,
      password: password || 'blank',
      phonenumber: phone,
      location: location,
      jobrole: role,
      bio: bio,
      isadmin: admin,
      isactive: active,
      brokeragecodes: [broker.information.brokerages[0].code],
    };
    let code = {
      brokerage_code: broker.information.brokerages[0].code,
    };
    var b64 = previewCanvasRef?.current?.toDataURL("image");
    if (b64) {
      data.brokerimage = b64;
    }
    dispatch(addNewUser(data))
      .then(
        setTimeout(() => {
          dispatch(
            sendSignupEmail({
              emailid: data.email,
              frontEndOrigin: window.location.origin,
            })
          );
          dispatch(storeEmailId(data.email));
          dispatch(toggleNewUserModel(false));
        }, 100)
      )
      .then(
        setTimeout(() => {
          dispatch(getUserDetails(code));
          Array.isArray(updateErrors) && !updateErrors.length
            ? toast(updateErrors)
            : toast.success("New User Created");
        }, 2000)
      );
  };
  const onLocationChangeHandler = (values) => {
    setLocation(values[0].value);
  };
  let [disableBtn, setdisableBtn] = useState(false);
  useEffect(() => {
    // use effect to disable submit button until required fields answered 
     let data = {
      firstname: name,
      email: email,
      password: password,
      phonenumber: phone,
      location: location,
      jobrole: role,
      bio: bio,
      isadmin: admin,
      isactive: active,
      brokeragecodes: [broker.information.brokerages[0].code],
    };
    console.log(data)
    if([name, email, location].some(x => [undefined, '', null].includes(x) )){
      //mandatory not selected
      setdisableBtn(true)

    }else {
      setdisableBtn(false)
    }
  }, [name, email, phone, location, role, bio])
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "24px" }}
          >
            {brokerageAdminTranslations.addNewUser}
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(toggleNewUserModel(false));
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate autoComplete="off">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-9">
                  <input
                    autoComplete="off"
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder="Enter Name"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row" style={{display:"none"}} >
                <label className="col-sm-3 col-form-label">Password</label>
                <div className="col-sm-9">
                  <input
                    type="password"
                    id="uPass"
                    name="uPass"
                    className="form-control"
                    placeholder="Enter Temporary Password"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Email</label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    id="uEmail"
                    name="uEmail"
                    className="form-control"
                    placeholder="Enter Email"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Contact</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uContact"
                    name="uContact"
                    className="form-control"
                    placeholder="Enter Contact"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setPhone(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Location</label>
                <div className="col-sm-9">
                  <Select
                    color={theme.COLORS.primary_navyblue}
                    options={
                      props.brokerageAddressList
                        ? props.brokerageAddressList.map(
                            ({ addr_line1, city, postal_code }) => ({
                              value:
                                addr_line1 + " " + city + " " + postal_code,
                              label:
                                addr_line1 + " " + city + " " + postal_code,
                            })
                          )
                        : []
                    }
                    onChange={(values) => onLocationChangeHandler(values)}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                </div>

                {/* <div className="col-sm-9">
                  <input
                    type="text"
                    id="location"
                    name="location"
                    className="form-control"
                    placeholder="Enter Location"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setLocation(event.target.value);
                    }}
                  />
                </div> */}
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Role/ Job Title
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="role"
                    name="role"
                    className="form-control"
                    placeholder="Enter Job Title/Role"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setJobRole(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Biography (max 250 chars)
                </label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    id="biography"
                    name="biography"
                    rows="3"
                    className="form-control"
                    placeholder="Enter Biography (max 250 chars)"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setBio(event.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  Language Preference
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={(() => {
                      const languageOptions = [
                        { value: "fr", label: "Français" },
                        { value: "en", label: "English" },
                      ];
                      const pref = user.languagepreference;
                      if (!pref) return languageOptions.find(opt => opt.value === "en");
                      if (typeof pref === 'string') {
                        // Map old format to new format
                        const normalizedPref = pref === "french" ? "fr" : pref === "english" ? "en" : pref;
                        return languageOptions.find(opt => opt.value === normalizedPref) || languageOptions.find(opt => opt.value === "en");
                      }
                      return pref;
                    })()}
                    name="languagePreference"
                    options={[
                      {
                        value: "fr",
                        label: "Français",
                      },
                      {
                        value: "en",
                        label: "English",
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        languagePreference: option.value,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Admin</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUAdmin"
                    name="isUAdmin"
                    onChange={(event) => {
                      setAdmin(event.target.checked);
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Active</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUActive"
                    name="isUActive"
                    defaultChecked={active}
                    onChange={(event) => {
                      setActive(event.target.checked);
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Permissions</label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={user.permissions ? user.permissions : [
                      { value: "goToMarket", label: "Able to go to market" },
                      { value: "bind", label: "Able to bind" },
                    ]}
                    isMulti
                    name="permissions"
                    options={[
                      { value: "goToMarket", label: "Able to go to market" },
                      { value: "bind", label: "Able to bind" },
                    ]}
                    onChange={(option) => {
                      // setSelectedOption(option);
                      // getAddInsurerStatus(option.value);
                      // setSelectedInsurerName(option.label);

                      setSelecteduser({
                        ...selecteduser,
                        uPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  Prospects Permissions
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={
                      user.brokerProspectsPermissions
                        ? user.brokerProspectsPermissions
                        : [
                            {
                              value: "AllProspects",
                              label: "Able to view all prospects",
                            },
                          ]
                    }
                    isMulti
                    name="brokerProspectsPermissions"
                    options={[
                      {
                        value: "AllProspects",
                        label: "Able to view all prospects",
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        uProspectPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>

              <UploadBrokerImage
                selecteduser={selecteduser}
                user={user}
                setSelecteduser={setSelecteduser}
                broker={broker}
                previewCanvasRef={previewCanvasRef}
              ></UploadBrokerImage>

              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <ActionButton
                    text={brokerageAdminTranslations.addNewUser}
                    onClick={onAddButtonClick}
                    disabled={disableBtn}
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                      width: "auto",
                      minWidth: "200px",
                      maxWidth: "100%",
                      height: "auto",
                      maxHeight: "none",
                      minHeight: "40px"
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 1,
    }}
  />
);
const UpdateUserModal = (props) => {
  const newUserModalState = useSelector(getUpdateUserModelStatus);
  const updateUser = useSelector(getUpdateUserSelected);
  const updateErrors = useSelector(getUpdateErrors);
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);
  useEffect(() => {
    if (
      updateErrors.length > 0 &&
      updateErrors == "sucess" &&
      newUserModalState
    ) {
      toast("User updated");
    } else if (updateErrors.length > 0 && newUserModalState) {
      toast(updateErrors);
    }
  }, [updateErrors]);
  return (
    <Modal
      size="md"
      isOpen={newUserModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "95vh",
          width: "50vw",
          position: "absolute",
          top: "2vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <UpdateUser
        brokerageCode={props.brokerageCode}
        user={updateUser}
        brokerageAddressList={props.brokerageAddressList}
      ></UpdateUser>
    </Modal>
  );
};

const UpdateUser = (updateUser) => {
  const user = updateUser.user;
  
  const broker = useSelector(getBrokerInformation);

  const languagepreference = broker.information.languagepreference;

  const userManagementModalTranslations =
    translations[languagepreference].userManagementModal;
  const previewCanvasRef = useRef(null);
  let userList = useSelector(getUserInformation);
  const [selecteduser, setSelecteduser] = useState({
    uName: user.firstname + " " + user.lastname,
    uEmail: user.user.email,
    uContact: user.phonenumber,
    uLocation: user.location
      ? user.location
      : user.brokerages[0]
      ? user.brokerages[0].address[0] || user.brokerages[0].address
        ? user.brokerages[0].address[0]
          ? user.brokerages[0].address[0].city
          : user.brokerages[0].address.city
        : ""
      : "",
    uImage: user.image,
    uRole: user.jobrole,
    uBiography: user.bio,
    uActive: user.isactive,
    uAdmin: user.isadmin,
    uId: user._id,
    uPermissions: user.permissions || [],
    uProspectPermissions: user.brokerProspectsPermissions || [],
    languagePreference: user.languagepreference,
  });
  const dispatch = useDispatch();
  const onLocationChangeHandler = (values) => {
    setSelecteduser({
      ...selecteduser,
      uLocation: values[0].value,
    });
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              {userManagementModalTranslations.updateUser}
            </span>
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(toggleUpdateUserModel(false));
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate autoComplete="off">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.name}
                </label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    autoComplete="given-name"
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder={userManagementModalTranslations.enterName}
                    defaultValue={user.firstname + " " + user.lastname}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uName: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.email}
                </label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    id="uEmail"
                    name="uEmail"
                    className="form-control"
                    placeholder={userManagementModalTranslations.enterEmail}
                    defaultValue={user.user.email}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uEmail: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.contact}
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uContact"
                    name="uContact"
                    className="form-control"
                    placeholder={userManagementModalTranslations.enterContact}
                    defaultValue={user.phonenumber}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uContact: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.location}
                </label>
                <div className="col-sm-9">
                  <Select
                    color={theme.COLORS.primary_navyblue}
                    placeholder={
                      selecteduser?.uLocation
                        ? selecteduser.uLocation
                        : "please choose"
                    }
                    options={
                      updateUser.brokerageAddressList
                        ? updateUser.brokerageAddressList.map(
                            ({ addr_line1, city, postal_code }) => ({
                              value:
                                addr_line1 + " " + city + " " + postal_code,
                              label:
                                addr_line1 + " " + city + " " + postal_code,
                            })
                          )
                        : []
                    }
                    onChange={(values) => onLocationChangeHandler(values)}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.roleJobTitle}
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uRole"
                    name="uRole"
                    className="form-control"
                    placeholder={
                      userManagementModalTranslations.enterJobTitleRole
                    }
                    defaultValue={user.jobrole}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uRole: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  {userManagementModalTranslations.biographyMax250Chars}
                </label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    id="uBiography"
                    name="uBiography"
                    rows="3"
                    className="form-control"
                    placeholder={
                      userManagementModalTranslations.enterBiographyMax250Chars
                    }
                    defaultValue={user.bio}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uBiography: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  {userManagementModalTranslations.languagePreference}
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={(() => {
                      const languageOptions = [
                        { value: "fr", label: "Français" },
                        { value: "en", label: "English" },
                      ];
                      const pref = user.languagepreference;
                      if (!pref) return languageOptions.find(opt => opt.value === "en");
                      if (typeof pref === 'string') {
                        
                        // Map old format to new format
                        const normalizedPref = pref === "fr" ? "fr" : pref === "english" ? "en" : pref;
                        return languageOptions.find(opt => opt.value === normalizedPref) || languageOptions.find(opt => opt.value === "en");
                      }
                      return pref;
                    })()}
                    name="languagePreference"
                    options={[
                      {
                        value: "fr",
                        label: "Français",
                      },
                      {
                        value: "en",
                        label: "English",
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        languagePreference: option.value,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {userManagementModalTranslations.admin}
                </label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUAdmin"
                    name="isUAdmin"
                    defaultChecked={user.isadmin}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uAdmin: event.target.checked,
                      });
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {userManagementModalTranslations.active}
                </label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUActive"
                    name="isUActive"
                    defaultChecked={user.isactive}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uActive: event.target.checked,
                      });
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div
                className="form-group row"
                style={{ display: selecteduser.uActive ? "none" : "flex" }}
              >
                <label className="col-sm-3 form-check-label">
                  {" "}
                  {userManagementModalTranslations.transferProspects}
                </label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    id="isUTransfer"
                    name="isUTransfer"
                    onChange={(e) => {
                      let selectedUser = e.target.value;
                      const brokerInfo = userList.find(
                        (broker) =>
                          `${broker.firstname} ${broker.lastname}` ===
                          selectedUser
                      );
                      if (brokerInfo) {
                        setSelecteduser({
                          ...selecteduser,
                          uTransfer: brokerInfo._id,
                        });
                      }
                    }}
                    list="otherusers"
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                  <datalist id="otherusers">
                    {userList.map((broker) => {
                      return (
                        <option
                          key={broker._id}
                          value={`${broker.firstname} ${broker.lastname}`}
                        ></option>
                      );
                    })}
                  </datalist>
                </div>
              </div>

              <UploadBrokerImage
                selecteduser={selecteduser}
                user={user}
                setSelecteduser={setSelecteduser}
                broker={broker}
                previewCanvasRef={previewCanvasRef}
              ></UploadBrokerImage>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {userManagementModalTranslations.permissions}
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={user.permissions ? user.permissions : []}
                    isMulti
                    name="permissions"
                    options={[
                      {
                        value: "goToMarket",
                        label: userManagementModalTranslations.ableToGoToMarket,
                      },
                      {
                        value: "bind",
                        label: userManagementModalTranslations.ableToBind,
                      },
                    ]}
                    onChange={(option) => {
                      // setSelectedOption(option);
                      // getAddInsurerStatus(option.value);
                      // setSelectedInsurerName(option.label);

                      setSelecteduser({
                        ...selecteduser,
                        uPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  {userManagementModalTranslations.prospectsPermissions}
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={
                      user.brokerProspectsPermissions
                        ? user.brokerProspectsPermissions
                        : []
                    }
                    isMulti
                    name="brokerProspectsPermissions"
                    options={[
                      {
                        value: "AllProspects",
                        label:
                          userManagementModalTranslations.ableToViewAllProspects,
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        uProspectPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>
              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      let code = {
                        brokerage_code: broker.information.brokerages[0].code,
                      };
                      let data = {
                        name: selecteduser.uName,
                        email: selecteduser.uEmail,
                        contact: selecteduser.uContact,
                        location: selecteduser.uLocation,
                        isactive: selecteduser.uActive,
                        isadmin: selecteduser.uAdmin,
                        brokerage_code: broker.information.brokerages[0].code,
                        jobrole: selecteduser.uRole,
                        bio: selecteduser.uBiography,
                        id: selecteduser.uId,
                        permissions: selecteduser.uPermissions,
                        brokerProspectsPermissions:
                          selecteduser.uProspectPermissions,
                        languagePreference: selecteduser.languagePreference,
                      };
                      var b64 = previewCanvasRef?.current?.toDataURL("image");
                      if (b64) {
                        data.brokerimage = b64;
                      } else if (selecteduser.uImage) {
                        data.brokerimage = selecteduser.uImage;
                      }
                      if (selecteduser.uTransfer) {
                        data.transfer = selecteduser.uTransfer;
                      }

                      dispatch(updateDetails(data))
                        .then(() => {
                          dispatch(selectUpdateUser(updateUser.user));
                          // If updating current user's language preference, refresh broker state
                          if (selecteduser.uId === broker._id) {
                            dispatch(verifyToken());
                          }
                          setTimeout(() => {
                            dispatch(toggleUpdateUserModel(false));
                          }, 100);
                        })
                        .then(() => {
                          setTimeout(() => {
                            dispatch(getUserDetails(code));
                          }, 2000);
                        });
                    }}
                  >
                    {userManagementModalTranslations.update}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

export default UserManagement;
